<script>
    import { mapActions, mapState } from "vuex";
    import { apiUrl } from "@/utils";
    import TheSlider from "@main/packages/TheSlider";

    export default {
        name: "HomeFeatures",
        components: {
            TheSlider,
        },
        computed: {
            ...mapState("Bivan", ["homeFeatures"]),
        },
        serverPrefetch() {
            return this.getTextCards("home-features");
        },
        mounted() {
            if (this.homeFeatures.length === 0) {
                this.getTextCards("home-features");
            }
        },
        methods: {
            ...mapActions("Bivan", ["getTextCards"]),
            apiUrl,
        },
    };
</script>

<template>
    <div class="home-features">
        <div v-if="homeFeatures.length > 0" class="home-features__list mobile-hidden">
            <div class="home-features__item" v-for="item in homeFeatures" :key="item.id">
                <img :src="apiUrl(item.image)" :alt="item.title" />
                <div class="home-features__title">{{ item.title }}</div>
                <p v-html="item.text"></p>
            </div>
        </div>

        <div v-if="homeFeatures.length > 0" class="home-features__slider desktop-hidden">
            <the-slider
                name-slider="features"
                :is-arrow="false"
                :is-bullets="true"
                :bullets-options="{ dynamicBullets: true }"
            >
                <div
                    class="home-features__item swiper-slide"
                    slot="swiper-slide"
                    v-for="item in homeFeatures"
                    :key="item.id"
                >
                    <img :src="apiUrl(item.image)" :alt="item.title" />
                    <div class="home-features__title">{{ item.title }}</div>
                    <p v-html="item.text"></p>
                </div>
            </the-slider>
        </div>
    </div>
</template>

<style lang="scss">
    .home-features {
        &::before {
            content: "";
            display: block;
            width: 180px;
            height: 2px;
            margin: 0 auto 9px;
            background: #e0e0e0;
        }
    }

    .home-features__list {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            padding-top: 60px;
        }
    }

    .home-features__slider {
        padding-top: 40px;
    }

    .home-features__item {
        padding: 0 20px 36px;
        text-align: center;
        img {
            width: 200px;
            height: 200px;
            margin: 0 auto 10px;
        }
        p {
            color: var(--secondary-text);
            font-size: 14px;
            font-weight: 300;
            line-height: 26px;
        }
        &.swiper-slide {
            padding-bottom: 0;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: 33.3333%;
            max-width: 33.3333%;
            img {
                width: 130px;
                height: 130px;
                margin-bottom: 12px;
            }
        }
    }

    .home-features__title {
        margin-bottom: 12px;
        font-size: 18px;
        font-weight: 700;
        @include bp($bp-desktop-sm) {
            margin-bottom: 8px;
            font-size: 22px;
        }
    }
</style>
